import script from "./ProjectSettingsB24UserList.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectSettingsB24UserList.vue?vue&type=script&setup=true&lang=js"

import "./ProjectSettingsB24UserList.vue?vue&type=style&index=0&id=c2e4d732&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2e4d732"]])

export default __exports__